/* Dr.Primal — the TUDCA buy box.

   Division of labour, and it is deliberate:

   - Liquid rendered every price, saving, per-serving figure and button label, once per
     offer, at request time. This file only decides which offer's already-rendered nodes
     are visible. It never formats money, never multiplies a price and never recomputes a
     discount. The same page is served in EUR, GBP and USD.
   - Liquid stamped the variant id, the selling plan id and the advertised total on each
     offer card. This file reads `data-` attributes. It never matches a variant by title
     or option text — that is the defect that made one of the team's other themes show
     one price and charge another.
   - There is no mode any more. An offer IS a plan: the 90-Day card, the 30-Day card and
     the one-time option are three separate variants, each carrying its own
     `data-dp-plan`, which Liquid took from that variant's own single
     `selling_plan_allocation` after checking it against the id the block named. Never by
     list position. An offer with no plan posts no `selling_plan` key at all — never an
     empty one.
   - Add to basket is ONE request carrying ONE line. No `/cart/clear.js`, no discount
     code, no `_bundle_*` properties, and no gift lines — there are no gifts.
   - After the add it RECONCILES. See `reconcile` below for what that means now and why
     it still earns its place.

   The form is marked `data-dp-cart-managed` so `dp-cart-drawer.js` leaves it alone. Two
   handlers on one form is a documented production defect in the other themes. */
(function () {
  'use strict';

  var SECTIONS = 'dp-cart-drawer,dp-header';

  var box = null;
  var form = null;
  var errorNode = null;
  var busy = false;

  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function sectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  function guard() {
    return window.DPCartGuard || null;
  }

  function cards() {
    // The buy-now button carries `data-dp-tier-card` only so add() can read its
    // variant id; it is not a card and takes no part in selection.
    return Array.prototype.slice.call(
      box.querySelectorAll('[data-dp-tier-card]:not([data-dp-buy-now])')
    );
  }

  function cardFor(id) {
    return box.querySelector('[data-dp-tier-card="' + id + '"]');
  }

  function tierId() {
    return box.getAttribute('data-dp-tier');
  }

  function planFor(card) {
    if (!card) return '';
    return card.getAttribute('data-dp-plan') || '';
  }

  /* The advertised total, in the same integer cents Liquid printed it in and the Cart
     API reports back. Nothing is computed from a displayed string.

     `data-dp-total` is the BILLED figure — 11700 on the 90-Day offer, not the 3900 the
     card shows per month. Reconciliation compares the cart against this. Comparing
     against the per-month figure would fail on every 90-Day order, and a guard that
     cries wolf gets switched off; this one is load-bearing. */
  function advertised(card) {
    return parseInt(card.getAttribute('data-dp-total'), 10);
  }

  /* ---------- rendering ---------- */

  function render() {
    var tier = tierId();

    // One node per offer per slot, so this is a single match on `data-dp-for`. The old
    // two-nodes-per-tier price swap is gone with the subscribe checkbox: a hidden node
    // can no longer be holding the wrong mode's price.
    Array.prototype.forEach.call(box.querySelectorAll('[data-dp-node]'), function (node) {
      node.hidden = node.getAttribute('data-dp-for') !== tier;
    });

    cards().forEach(function (card) {
      var selected = card.getAttribute('data-dp-tier-card') === tier;
      card.classList.toggle('dp-offer--selected', selected);
      card.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    syncForm();
    announce();
  }

  /* Keep the plain form posting the same line the JSON payload would, so the page still
     works with JavaScript switched off or broken. The selling plan input is DISABLED
     rather than emptied when the offer is one-time, so the key is absent from the post
     instead of being sent blank. */
  function syncForm() {
    if (!form) return;
    var card = cardFor(tierId());
    if (!card) return;

    var tierInput = form.querySelector('[data-dp-input="tier"]');
    var planInput = form.querySelector('[data-dp-input="plan"]');
    if (tierInput) tierInput.value = card.getAttribute('data-dp-tier-card');

    var plan = planFor(card);
    if (planInput) {
      planInput.value = plan;
      planInput.disabled = !plan;
    }
  }

  /* The sticky bar mirrors strings Liquid rendered — it is handed the text, never the
     numbers, so it cannot format a price differently from the buy box. */
  function announce() {
    var visible = function (selector) {
      var nodes = box.querySelectorAll(selector);
      for (var i = 0; i < nodes.length; i += 1) {
        if (!nodes[i].hidden) return nodes[i].textContent.trim();
      }
      return '';
    };

    document.dispatchEvent(
      new CustomEvent('dp:buybox:change', {
        detail: {
          tier: tierId(),
          // The per-month figure, with its `/mo` unit inside the same node — so a bar
          // mirroring this string can never show a monthly number without saying so.
          price: visible('.dp-buy__price'),
          // The billed line: the amount actually charged and when. A duplicated Add
          // control must carry it, not just the per-month presentation.
          billed: visible('.dp-buy__billed'),
          plan: visible('[data-dp-plan-line] [data-dp-node]'),
          label: visible('[data-dp-buy-submit] [data-dp-node]'),
          soldOut: box.getAttribute('data-dp-sold-out') === 'true',
        },
      })
    );
  }

  /* ---------- state ---------- */

  function select(id) {
    var card = cardFor(id);
    if (!card) return;
    if (card.hasAttribute('data-dp-buy-now')) return;
    if (card.getAttribute('data-dp-available') !== 'true') return;
    box.setAttribute('data-dp-tier', id);
    clearError();
    render();
  }

  function selectableCards() {
    return cards().filter(function (card) {
      return card.getAttribute('data-dp-available') === 'true';
    });
  }

  function move(delta) {
    var available = selectableCards();
    if (!available.length) return;
    var index = available.findIndex(function (card) {
      return card.getAttribute('data-dp-tier-card') === tierId();
    });
    var next = (index + delta + available.length) % available.length;
    var target = available[next];
    select(target.getAttribute('data-dp-tier-card'));
    target.focus();
  }

  /* ---------- errors ---------- */

  function clearError() {
    if (!errorNode) return;
    errorNode.hidden = true;
    errorNode.textContent = '';
  }

  function showError(message) {
    if (!errorNode) return;
    errorNode.textContent = message;
    errorNode.hidden = false;
  }

  /* Copy comes from Liquid, through `| t`, stamped on the buy box as data attributes.
     No inline <script>, and no English hard-coded in a JS file. */
  function message(name) {
    return box.getAttribute('data-dp-msg-' + name) || '';
  }

  /* ---------- add to basket ---------- */

  function readJson(response) {
    return response.json().then(
      function (body) {
        if (response.ok) return body;
        var detail = body && (body.description || body.message);
        throw new Error(detail || message('error'));
      },
      function () {
        throw new Error(message('error'));
      }
    );
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(readJson);
  }

  /* Two questions, and both have to answer yes:
       1. is there a line for the variant we asked for, carrying the plan we asked for?
       2. is it priced, per unit, at no MORE than the BILLED figure the card advertised?

     Question 2 is one-sided on purpose. The promise being kept is "never charged more
     than advertised", so a cheaper line — a launch promo, a market discount — is not a
     failure and must not take checkout offline for a basket in the customer's favour.

     WHAT THIS STILL GUARDS, because the old answer is no longer true. It was written to
     catch a Buy X Get Y that failed to fire; there are no gifts now. Its second
     rationale, a subscription discount that failed to apply, is gone too: the saving
     lives in the variant price, so there is no subscription discount that CAN fail.
     What is left is the class of failure it actually exists for — a silent divergence
     between the advertised figure and the charged one: a page rendered against a price
     that has since changed in the admin, a market or currency mismatch between what
     Liquid rendered and what the cart charges, and any automatic discount nobody
     expected. Do not weaken it.

     Unit prices, not line prices: a customer who already had this variant in the basket
     gets a merged line at quantity two, and the question is still what one costs.

     Lines are found by variant id AND selling plan rather than by line key. A key is not
     stable across cart changes — removing one half of a Buy X Get Y pair rewrites the
     other half's key — so a key is safe to read from a single response and unsafe to
     store. The plan is half the identity: Shopify keeps the one-time line and the
     subscription line for the same variant apart, so a customer who adds a tier once and
     then subscribes to it has two lines. Matching on the variant alone found the
     one-time line, expected it to carry a plan, and reported a mismatch on a basket that
     was entirely correct — with no way out but emptying it. */
  function planOf(line) {
    return line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
      ? String(line.selling_plan_allocation.selling_plan.id)
      : '';
  }

  function lineFor(cart, variantId, plan) {
    for (var i = 0; i < cart.items.length; i += 1) {
      var line = cart.items[i];
      if (String(line.variant_id) === String(variantId) && planOf(line) === String(plan || '')) {
        return line;
      }
    }
    return null;
  }

  function unitPrice(line) {
    if (!line.quantity) return line.final_line_price;
    return Math.round(line.final_line_price / line.quantity);
  }

  function reconcile(context) {
    var problems = [];
    var variants = [];

    var offerLine = lineFor(context.after, context.variantId, context.plan);
    if (!offerLine) {
      problems.push(
        'no line for offer variant ' +
          context.variantId +
          ' carrying plan "' +
          (context.plan || '') +
          '"'
      );
      // Plan deliberately omitted: the line we asked for is not there, so the line that
      // IS there — the same variant on some other plan — is the one to hold the block
      // on. An entry with no plan matches the variant whatever plan it carries.
      variants.push({ id: context.variantId });
    } else if (unitPrice(offerLine) > context.advertised) {
      problems.push('offer costs ' + unitPrice(offerLine) + ', advertised ' + context.advertised);
      variants.push({ id: context.variantId, plan: context.plan || '' });
    }

    return { ok: problems.length === 0, problems: problems, variants: variants };
  }

  function setBusy(state) {
    busy = state;
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-dp-buy-submit], [data-dp-buybox-add], [data-dp-buybox-add-tier], [data-dp-buy-now]'),
      function (button) {
        button.disabled = state;
      }
    );
  }

  function add(trigger, cardOverride) {
    if (busy) return;
    var card = cardOverride || cardFor(tierId());
    if (!card || card.getAttribute('data-dp-available') !== 'true') return;

    clearError();
    setBusy(true);

    var variantId = card.getAttribute('data-dp-tier-card');
    var plan = planFor(card);
    var expected = advertised(card);

    // One line, never more. `selling_plan` is OMITTED entirely on a one-time offer —
    // never sent as null or as an empty string.
    var offerLine = { id: variantId, quantity: 1 };
    if (plan) offerLine.selling_plan = plan;

    var items = [offerLine];

    // Whether the POST itself went through. Everything after it is verification, and a
    // verification that could not run is NOT the same as a request that never landed —
    // the lines are in the basket either way. Reporting "nothing has been charged" for
    // the second case is the one lie this file must never tell.
    var posted = false;
    var added = null;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: SECTIONS,
        sections_url: sectionsUrl(),
      }),
    })
      .then(function (response) {
        // Read `ok` off the raw response: a 200 whose body could not be parsed is still
        // an add the server accepted, and the lines are still in the basket.
        if (response.ok) posted = true;
        return readJson(response);
      })
      .then(function (result) {
        added = result;
        return getCart().then(function (after) {
          return { result: result, after: after };
        });
      })
      .then(function (payload) {
        var verdict = reconcile({
          after: payload.after,
          advertised: expected,
          variantId: variantId,
          plan: plan,
        });

        // Either way the lines are in the basket, so the header count and the drawer
        // contents are refreshed. Only a clean result opens the drawer.
        var detail = { sections: payload.result.sections, open: verdict.ok };
        if (verdict.ok) detail.trigger = trigger;

        // A clean add does NOT clear the flag from here. Clearing it unconditionally on
        // success let a raised guard be lifted by an add that had nothing to do with the
        // wrongly priced line still sitting in the basket: three clicks from "the guard
        // worked" to paying an amount the page never advertised. The `dp:cart:updated`
        // dispatched below is what the guard listens to, and it answers by re-reading
        // `/cart.js`.
        if (!verdict.ok) {
          console.error('[dp-buy-box] reconciliation failed:', verdict.problems.join('; '));
          showError(message('mismatch'));
          if (guard()) {
            guard().raise(message('blocked'), verdict.variants, payload.after.token);
          }
        }

        document.dispatchEvent(new CustomEvent('dp:cart:updated', { detail: detail }));
      })
      .catch(function (error) {
        console.error('[dp-buy-box]', error);

        if (!posted) {
          showError(error.message || message('error'));
          return;
        }

        // The lines ARE in the basket and we could not confirm what they cost. Block
        // checkout and say so: the guard's own policy is that leaving the flag up is the
        // safe failure. The flagged entries carry no plan, so the block holds against
        // whatever those lines turn out to be.
        showError(message('unverified'));
        if (guard()) {
          guard().raise(message('blocked'), [{ id: variantId }]);
        }

        // The basket really did change, so show what it now holds — closed, never
        // opened. Without this the header count and the drawer keep describing a basket
        // that no longer exists.
        if (added && added.sections) {
          document.dispatchEvent(
            new CustomEvent('dp:cart:updated', {
              detail: { sections: added.sections, open: false },
            })
          );
        }
      })
      .then(function () {
        setBusy(false);
      });
  }

  /* ---------- wiring ---------- */

  function init() {
    box = document.querySelector('[data-dp-buy-box]');
    if (!box) return;

    form = box.querySelector('[data-dp-buy-form]');
    errorNode = box.querySelector('[data-dp-buy-error]');

    /* The two plan cards only ever SELECT. The one-time option is a buy-now BUTTON
       (client, 2026-09-04): activating it adds its own line immediately, from its own
       stamped variant, plan and total, without touching the selection.

       The history matters here, because this is the third shape. Add-on-activate was
       tried on 2026-09-02 and reversed on 2026-09-03 because the option was a radio
       then, and arrowing onto a radio — how a keyboard reaches one at all — committed
       a purchase. As a button OUTSIDE the radiogroup the objection is gone: arrow keys
       cannot land on it, and the only activations are a deliberate click or Enter/Space
       on a focused button, which is what a buy control is supposed to do. */
    box.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      var buyNow = event.target.closest('[data-dp-buy-now]');
      if (buyNow) {
        if (buyNow.getAttribute('data-dp-available') === 'true') add(buyNow, buyNow);
        return;
      }

      var card = event.target.closest('[data-dp-tier-card]');
      if (card) select(card.getAttribute('data-dp-tier-card'));
    });

    box.addEventListener('keydown', function (event) {
      if (!(event.target instanceof Element)) return;
      var card = event.target.closest('[data-dp-tier-card]');
      if (!card) return;
      // The buy-now button handles its own Enter and Space natively as a <button>.
      if (card.hasAttribute('data-dp-buy-now')) return;

      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        select(card.getAttribute('data-dp-tier-card'));
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        add(event.submitter || form.querySelector('[data-dp-buy-submit]'));
      });
    }

    // The sticky bar loads after this file and misses the first announcement, so it
    // asks for one once it is listening.
    document.addEventListener('dp:buybox:sync', announce);

    // The sticky bar's button and the header CTA are in other sections, so they are
    // delegated from the document rather than bound directly. A trigger naming a tier
    // (the header CTA names the 90-Day pack) selects that card first and adds through
    // the ordinary path — and when the named card is missing or unavailable the click
    // is NOT intercepted, so the trigger's own href carries the reader to the PDP
    // instead of adding something other than what the button advertised.
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var trigger = event.target.closest('[data-dp-buybox-add], [data-dp-buybox-add-tier]');
      if (!trigger) return;

      var tier = trigger.getAttribute('data-dp-buybox-add-tier');
      if (tier) {
        var card = cardFor(tier);
        if (!card || card.getAttribute('data-dp-available') !== 'true') return;
        event.preventDefault();
        select(tier);
        add(trigger);
        return;
      }

      event.preventDefault();
      add(trigger);
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
